import React from 'react';

const Hamburger=() => {
    return(
        <div className='hamburger'>
            <div className='burger'></div>
            <div className='burger'></div>
            <div className='burger'></div>
        </div>
    );
}

export default Hamburger;